// assets
import { IconSchool } from '@tabler/icons';

// constant
const icons = { IconSchool };

// ==============================|| PROGRAM MENU ITEMS ||============================== //

const program = {
  id: 'program',
  title: 'Program Belajar',
  type: 'group',
  children: [
    {
      id: 'program-current',
      title: 'Program Belajar',
      type: 'item',
      url: '/program',
      icon: icons.IconSchool,
      breadcrumbs: false
    }
  ]
};

export default program;

